import { OwcTypography } from '@one/react';
import { useTranslation } from 'core/i18n';
import { RefreshButton } from '../generic-buttons';
import { ContentWithFooterLayout } from '../layouts';
import { BlockedAppLayout } from './blocked-app-screen.style';

export const BlockedAppScreenComponent: React.FC = () => {
  const { t } = useTranslation('global');

  return (
    <ContentWithFooterLayout footer={<RefreshButton />}>
      <BlockedAppLayout>
        <OwcTypography variant="subtitle1" mode="medium">
          {t('app.blocked.title')}
        </OwcTypography>
        <img src="/assets/images/fence.svg" alt={t('app.blocked.title')} />
        <OwcTypography variant="body1" mode="regular" className="text-center">
          {t('app.blocked.message')}
        </OwcTypography>
      </BlockedAppLayout>
    </ContentWithFooterLayout>
  );
};
